import React, { useEffect, useState } from 'react';
import { RenewHealthStatus } from "../../../utils/constants";
import { capitalizeWords, getRenewHealthStatusColor, updateThePlanNewName } from "../../../utils/util";

const RenewHealthCard = ({
  status,
  mrn,
  mobileNumber,
  emiratesId,
  fullName,
  coveragePlanName,
  expiryDate,
  handleRenewCard,
  translationMap = {},
  paymentStatus,
  isEligibile,
  coveragePayorCode,
  index,
  isMarkedEpd
}) => {
  const [cardStatus, setCardStatus] = useState('');
  const [disableRenewBtn, setDisableRenewBtn] = useState(false);

  const newPlanName = updateThePlanNewName(coveragePayorCode, coveragePlanName, translationMap);

  useEffect(() => {

    const normalizedStatus = typeof status === 'string' ?
    status.toLowerCase().replace(/\s+/g, '') :
    '';

    let translatedStatus = translationMap?.[normalizedStatus] || status || '';

    if (paymentStatus === 'INPROGRESS') {
      translatedStatus = translationMap?.inprogress || 'In Progress';
      setDisableRenewBtn(true);
    } else if (paymentStatus === 'INITIATED') {
      translatedStatus = translationMap?.renewHealthInitiatedPaymentMessage || 'Payment Initiated';
      setDisableRenewBtn(true);
    } else {
      setDisableRenewBtn(false);
    }
    setCardStatus(translatedStatus);
  }, [status, paymentStatus, translationMap]);

  const showRenewButton =
  status === RenewHealthStatus.expired.name &&
  isEligibile &&
  !isMarkedEpd;


  return (
    <div className="status_main_box status_main_box3">
            <div className="content_box">
                <p className="active">
                    <span className={`circle_icon ${getRenewHealthStatusColor(status)}_icon`}></span>
                    {cardStatus}
                </p>

                <h6 className="name_txt">{capitalizeWords(fullName)}</h6>

                <ul className="detail_box">
                    <li>
                        <p>
                            <span>{translationMap?.mrn}</span>
                            <p>{mrn}</p>
                        </p>
                    </li>
                    <li>
                        <p>
                            <span>{translationMap?.mobileNumber}</span>
                            <p style={{ direction: 'ltr' }}>{mobileNumber}</p>
                        </p>
                    </li>
                    <li>
                        <p>
                            <span>{translationMap?.emiratesId}</span>
                            <p>{emiratesId}</p>
                        </p>
                    </li>
                    <li>
                        <p>
                            <span>{translationMap?.coveragePlanName}</span>
                            <p>{newPlanName}</p>
                        </p>
                    </li>
                    <li>
                        <p>
                            <span>{translationMap?.expiryDate}</span>
                            <p>{expiryDate}</p>
                        </p>
                    </li>
                </ul>
            </div>

            {showRenewButton &&
      <div className="inner_bnt_box">
                    <button
          className={disableRenewBtn ? 'disabled_btn_link' : 'blue_btn_link'}
          onClick={() => handleRenewCard(index)}
          disabled={disableRenewBtn}>
          
                        {translationMap?.renewCoveragePlan}
                    </button>
                </div>
      }
        </div>);

};

export default RenewHealthCard;